module.exports = __webpack_public_path__ + "static/media/privatebin.64f1dfe4.svg";